export const palettes = {
  // --- Core products (existing, hand-tuned) ---
  JetBrains: ["#ed3d7d", "#FDBC2C", "#6520b5"],
  "IntelliJ IDEA": ["#007efc", "#fe315d", "#f97a12"],
  PhpStorm: ["#b345f1", "#765af8", "#ff318c"],
  PyCharm: ["#fcf84a", "#21d789", "#07c3f2"],
  RubyMine: ["#fc801d", "#fe2857", "#9039d0"],
  WebStorm: ["#087cfa", "#07c3f2", "#fcf84a"],
  CLion: ["#21d789", "#009ae5", "#ed358c"],
  DataGrip: ["#22d88f", "#9775f8", "#ff318c"],
  GoLand: ["#b74af7", "#0d7bf7", "#3bea62"],
  ReSharper: ["#c21456", "#e14ce3", "#fdbc2c"],
  "ReSharper C++": ["#fdbc2c", "#e14ce3", "#c21456"],
  dotCover: ["#ff7500", "#e343e6", "#7866ff"],
  dotMemory: ["#7866ff", "#e343e6", "#ffbd00"],
  dotPeek: ["#00caff", "#7866ff", "#e343e6"],
  dotTrace: ["#fc1681", "#e14ce3", "#786bfb"],
  Rider: ["#077cfb", "#c90f5e", "#fdb60d"],
  TeamCity: ["#905cfb", "#0cb0f2", "#3bea62"],
  YouTrack: ["#0cb0f2", "#905cfb", "#ff318c"],
  Hub: ["#00b8f1", "#9758fb", "#ffee45"],
  Kotlin: ["#22b1ef", "#9062f7", "#fd8224"],
  MPS: ["#0b8fff", "#21d789", "#ffdc52"],
  DataSpell: ["#087cfa", "#21d789", "#fcf84a"],
  Qodana: ["#6b57ff", "#ff318c", "#fc801d"],
  Datalore: ["#087cfa", "#3bea62", "#fcf84a"],
  "Code With Me": ["#3bea62", "#009aaf", "#6b57ff"],

  // --- Extracted from background 1 images ---
  "AI Assistant": ["#2ea3fb", "#5637f1", "#4368f6"],
  Amper: ["#0c79ea", "#189bbf", "#2ac58e"],
  Aqua: ["#0786e2", "#01ce91", "#3867f5"],
  CodeCanvas: ["#0483e7", "#0564bf", "#24c599"],
  "Compose Multiplatform": ["#014def", "#0f03f0", "#4b07db"],
  Databao: ["#08d378", "#ef1bd4", "#52f061"],
  Exposed: ["#e200ee", "#6501e4", "#ef5ffe"],
  Fleet: ["#07aef4", "#8629e1", "#3d5af1"],
  Gateway: ["#fd7d38", "#6619c0", "#ef3da5"],
  Grazie: ["#705afe", "#9f7bfc", "#d6a1f9"],
  "IDE Services": ["#fd7d38", "#6619c0", "#ef3da5"],
  "JetBrains .NET": ["#aa28ca", "#da39ea", "#771dae"],
  "JetBrains AI": ["#394bb9", "#2f2880", "#211550"],
  "JetBrains Air": ["#ff9419", "#ff021d", "#e600ff"],
  "JetBrains Academy": ["#20d788", "#6958F6", "#B74AF7"],
  "JetBrains Game Dev": ["#97e308", "#8968f0", "#553e9b"],
  "JetBrains IDEs": ["#fd7d38", "#6619c0", "#ef3da5"],
  "JetBrains Marketplace": ["#fd7d38", "#6619c0", "#ef3da5"],
  "JetBrains for Data": ["#d61bb5", "#41d8f7", "#0d90b7"],
  Junie: ["#2d8e35", "#1d5a22", "#2d8e35"],
  "Kotlin Multiplatform": ["#6503e6", "#0d1bea", "#314df9"],
  Ktor: ["#fe5a2a", "#b403ee", "#4603d7"],
  Mellum: ["#0878ec", "#3abefa", "#1ecb98"],
  "PyCharm (Data)": ["#1ddc71", "#26cfed", "#e7e429"],
  RustRover: ["#db5c0a", "#a37323", "#2a8f52"],
  "Startup Program": ["#fd7d38", "#6619c0", "#ef3da5"],
  "Toolbox App": ["#fd7d38", "#6619c0", "#ef3da5"],
  "University Programs": ["#20d688", "#6b57fe", "#19a468"],

  // --- Derived from related products (no own backgrounds) ---
  "CLion Nova": ["#21d789", "#009ae5", "#ed358c"],
  "C++ Tools": ["#21d789", "#009ae5", "#ed358c"],
  "dotNet Tools": ["#aa28ca", "#da39ea", "#771dae"],
  dotUltimate: ["#077cfb", "#c90f5e", "#fdb60d"],
  Writerside: ["#fe2857", "#ff45ed", "#b74af7"],
  "Remote Development": ["#fd7d38", "#6619c0", "#ef3da5"],
  Client: ["#fd7d38", "#6619c0", "#ef3da5"],
  "Innovation Hub": ["#fd7d38", "#6619c0", "#ef3da5"],
  Koog: ["#22b1ef", "#9062f7", "#fd8224"],

  // --- Legacy products (kept for compatibility) ---
  AppCode: ["#087cfa", "#07c3f2", "#21d789"],
  Space: ["#009AE5", "#3BEA62", "#FCF84A"],
  Upsource: ["#22b1ef", "#9062f7", "#fd8224"],
  Mono: ["#ffffff", "#4c4c4c", "#000000"],
  "IntelliJ IDEA Edu": ["#0d7bf7", "#fe315d", "#f97a12"],
  "PyCharm Edu": ["#fcf84a", "#21d789", "#07c3f2"],
};
